import axios from "axios";

/* const apiUrl =
  "https://dev-unionservice.intravan.co.kr/Controllers/WETOService.aspx";
const apiFormDataUrl =
  "https://dev-unionservice.intravan.co.kr/Controllers/WETOBoardSave.aspx";
const apiBannerFormDataUrl =
  "https://dev-unionservice.intravan.co.kr/Controllers/WETOBannerSave.aspx";
const imageFileUploadUrl =
  "https://dev-unionservice.intravan.co.kr/controllers/uploadImageWETO.aspx";
const apiDomain = "https://dev-unionservice.intravan.co.kr"; */

const apiUrl =
  "http://unionservice.intravan.co.kr/Controllers/WETOService.aspx";
const apiFormDataUrl =
  "http://unionservice.intravan.co.kr/Controllers/WETOBoardSave.aspx";
const apiBannerFormDataUrl =
  "http://unionservice.intravan.co.kr/Controllers/WETOBannerSave.aspx";
const imageFileUploadUrl =
  "http://unionservice.intravan.co.kr/controllers/uploadImageWETO.aspx";
const apiDomain = "http://unionservice.intravan.co.kr";

const axiosConfig = {
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
  },
};

async function reqData(jsonData) {
  const res = await axios.post(apiUrl, JSON.stringify(jsonData), axiosConfig);
  return res;
}

async function reqFormData(formData) {
  const res = await axios({
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    url: apiFormDataUrl,
    data: formData,
  });

  return res;
}

async function reqFormDataBanner(formData) {
  const res = await axios({
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    url: apiBannerFormDataUrl,
    data: formData,
  });

  return res;
}

async function LoginAccount(userid, userpw) {
  const reqData = {
    servicename: "Login",
    userid: userid,
    passwd: userpw,
  };

  const res = await axios.post(apiUrl, JSON.stringify(reqData), axiosConfig);
  return res;
}

async function LoginToken(userToken) {
  const reqData = {
    servicename: "Login",
    userToken: userToken,
  };

  const res = await axios.post(apiUrl, JSON.stringify(reqData), axiosConfig);
  return res;
}

export {
  reqData,
  LoginAccount,
  LoginToken,
  reqFormData,
  reqFormDataBanner,
  imageFileUploadUrl,
  apiDomain,
};
